import { Route } from '@angular/router';
import { SbIcons } from '@ngx-seatback/icons';
import { RoutingID } from '../../../../sb-routing-enum';
import { GeneratedReportsComponent } from '../../../../../pages/statistics/standardReporting/generated-reports/generated-reports.component';

export const generatedReport: Route = {
  path: 'generatedReport',
  title: 'nav.reporting.generatedReports',
  data: {
    breadcrumb: 'nav.reporting.generatedReports',
    icon: SbIcons.pieChartList,
  },
  children: [
    {
      path: '',
      component: GeneratedReportsComponent,
      data: {
        id: RoutingID.generatedReport,
      },
    },
  ],
};
